export default __webpack_public_path__ + "static/howltsans-b-754168d1f36dae8ce4abba1f3d6b10fd.woff2";